'use strict';

(function (snapOnline, $) {;
    // Ensure required nested namespaces are declared.
    snapOnline.Messages = snapOnline.Messages || {};

    function navigateTo(url) {
        window.location.replace(url);
    }
    function handleInlineEditMessage(message){
        switch (message.data.action) {
            case 'editfields': {
                    SnapOnline.SurveyEditing.changeMode(true, message.data.messageback);
                }
                break;
            case 'previewfields': {
                    SnapOnline.SurveyEditing.changeMode(false, message.data.messageback);
                }
                break;
            case 'savefields': {
                    SnapOnline.SurveyEditing.SaveInlineEdit();
                } 
                break;
            case 'cancelfields': {
                    SnapOnline.SurveyEditing.changeMode(false, message.data.messageback);//oddly this works better?
                    //SnapOnline.SurveyEditing.CancelInlineEdit(false);
                }
                break;
            default:
                console.error("unknown inline message action: " + message.data.action);
        }
    };

    // ----- Public interface from here -----
    snapOnline.Messages.HandleMessage = function (message) {
        if (message.origin != window.origin) {
            console.error("cross origin message from" + message.origin);
        } else if (!message.data.action){
            console.error("no message action from" + message.origin);
        } else  if (message.data && (typeof message.data.action == "string")){
            switch (message.data.action) {
                case 'editfields': 
                case 'previewfields':
                case 'savefields':
                case 'cancelfields': {
                        if (SnapOnline.SurveyEditing) {
                            handleInlineEditMessage(message);
                        } else {
                            console.error("Editing module not available");
                        }
                    }
                    break;
                case 'navigate': {
                        if (!message.data.url) {
                            console.error("Navigate message has no url");
                        } else {
                            navigateTo(message.data.url);
                        }
                    }
                    break;
                case 'rebuild': { //coming from child iframe, this one
                        if (!snapOnline.Dialogs) {
                            console.error("dialogs module not loaded");
                        } else {
                            var Seeding = null;
                            if (message.data.seeding) {
                                Seeding = message.data.seeding;
                            }
                            snapOnline.Dialogs.immediatelyDestroyDynamicDialogWindow();
                            //null surveyID is fetched from meta sol-resource-id
                            snapOnline.Dialogs.openQwizardWindow('Rebuild...', snapOnline.getResourceActionUrl('SurveyEditing', 'QwizardFromUi', null, { seeding: Seeding}));
                        }
                    }
                    break;
                case 'createnew': {
                        if (!snapOnline.HomePage) {
                            console.error("home page module not loaded");
                        } else if (!message.data.templateId) {
                            console.error("Create message has no template id");
                        } else {
                            var Seeding = null;
                            if (message.data.seeding) {
                                Seeding = message.data.seeding;
                            }
                            SnapOnline.HomePage.createSurveyFromTemplate(message.data.templateId, null, Seeding);
                        }
                    }
                    break;
                case 'runreport': {
                        if (!SnapOnline.AnalysisTab.analysisManager) {
                            console.error("analysis module not loaded");
                        } else {
                            SnapOnline.Dialogs.immediatelyDestroyDynamicDialogWindow();
                            var url = SnapOnline.getResourceActionUrl('QwizardUI', 'InlineAnalysis');
                            var manager = SnapOnline.AnalysisTab.analysisManager;
                            if (typeof manager.startAnalysis != "function") {
                                console.error("startAnalysis is missing");
                            }
                            var contextVals = new snapOnline.Analysis.ContextValues(message.data.context);
                            var filterVals = new snapOnline.Analysis.FilterValues(message.data.filter);
                            var onrefresh = function () { manager.startAnalysis("Report", message.data.name, false, true, contextVals, filterVals);  };
                            SnapOnline.Dialogs.createInlineAnalysisDialog(url, onrefresh);
                        }
                    }
                    break;
                case 'exportdata': {
                        if (!SnapOnline.Dialogs) {
                            console.error("dialog module not loaded");
                        } else {
                            var format = 0;
                            if (message.data.format === 'xlsx')
                                format = 1;
                            var url = SnapOnline.getResourceActionUrl('Response', 'InitiateDbLinkExport', message.data.surveyid, { linkName: message.data.name, formatId: format});
                            SnapOnline.Dialogs.createDownloadDialog(url);
                        }
                    }
                    break;
                case 'importdata':
                case 'replacedata': {
                        if (!SnapOnline.Dialogs) {
                            console.error("dialog module not loaded");
                        } else if (!SnapOnline.ResponsesPage) {
                            console.error("responses module not loaded");
                        } else {
                            var replaceAll = (message.data.action === 'replacedata');
                            var url = SnapOnline.getResourceActionUrl('Response', 'Import', message.data.surveyid, { linkName: message.data.name, replaceAll: replaceAll});
                            SnapOnline.Dialogs.launchImportDialog('Upload data file', url);
                        }
                    }
                    break;
                case 'setstatus': {
                        if (!SnapOnline.SummaryPage) {
                            console.error("SummaryPage module not loaded");
                        } else {
                            switch (message.data.status) {
                                case "start": {
                                    SnapOnline.SummaryPage.showStartDialog(false, true);
                                    }
                                    break;
                                case "resume": {
                                    SnapOnline.SummaryPage.showStartDialog(true, true);
                                    }
                                    break;
                                case "pause": {
                                    SnapOnline.SummaryPage.pauseSurveyFromQwizard();
                                    }
                                    break;
                                case "stop": {
                                    SnapOnline.SummaryPage.showStopDialog(true);
                                    }
                                    break;
                            }
                        }
                    }
                    break;
                case 'createspinner': {
                        if (!SnapOnline.Dialogs) {
                            console.error("dialogs module not loaded");
                        } else {
                            if (SnapOnline.Messages.spinner) {
                                SnapOnline.Dialogs.closeCustomDialog(snapOnline.Messages.spinner);
                            }
                            SnapOnline.Messages.spinner = snapOnline.Dialogs.waitDialog(message.data.waitText);
                        }
                    }
                    break;
                case 'removespinner': {
                        if (!SnapOnline.Dialogs) {
                            console.error("dialogs module not loaded");
                        } else {
                            if (SnapOnline.Messages.spinner) {
                                SnapOnline.Dialogs.closeCustomDialog(snapOnline.Messages.spinner);
                            }
                            SnapOnline.Messages.spinner = null;
                        }
                    }
                    break;
                default:
                    console.error("unknown message action: " + message.data.action);
            }
        }
    };

    snapOnline.Messages.MessageParent = function (message) {
        window.parent.postMessage(message, window.origin);
    };

    snapOnline.Messages.MessageQwizardUi = function (actionName) {
        var targetWindow = document.getElementById('UiFrame');
        if (!targetWindow) {
            console.error("cannot find target UiFrame");
        } else {
            var message = {};
            message.action = actionName;
            targetWindow.contentWindow.postMessage(message, window.origin);
        }
    };

    window.addEventListener('message', snapOnline.Messages.HandleMessage);

}(window.SnapOnline = window.SnapOnline || {}, jQuery));